
import Transformer from './../transformer'

export default class TypeTransformer extends Transformer {
  static fetch(type) {
    return {
      id: type.id,
      name: type.name
    }
  }

  static send(type) {
    return {
      id: type.id,
      name: type.name
    }
  }
}


// WEBPACK FOOTER //
// ./src/transformers/sinister/types.js